import { createSelector } from '@ngrx/store';
import { get } from '../../../shared/utils/func';
import { featureState } from './feature.name';

export const phoneNumberManagementState = createSelector(featureState, get('phoneNumberManagement'));

export const verifyingPhoneNumberDetails = createSelector(phoneNumberManagementState, get('verifyingPhoneNumbers'));
export const verifyingPhoneNumbers = createSelector(verifyingPhoneNumberDetails, details => Object.keys(details));
